export const LEARNING_PRIORITY = 'Learning Priority';
export const COMPETENCY_DEFAULT_PRACTICE_LEVEL = 0;
export const competencySteps = ['Select Competencies', 'Reflect on them'];
